import * as React from 'react';
import { SummaryDesktop } from './components/SummaryDesktop';
import { SummaryMobile } from './components/SummaryMobile';
import { useSelector } from 'react-redux';
import { selectIsIdentificationNeeded, selectIsPublishToHiddenBase } from '../../selectors/publishAvailable';
import { NeedIdentification } from '../NeedIdentification';
import { HiddenBaseContainer } from '../HiddenBase';
import { Device } from '../common/Device';
import { selectAutoProlongTooltipText, selectIsAutoProlongAvailable } from '../../selectors/checkoutInfo';
import { MultilineTotalContainer } from '../MultilineTotal';
import { selectSummaryViewMode } from '../../selectors/elementsVisibility';
import { Layout } from '../ServicePickerWidget/Layout';
import { Header2 } from '@cian/ui-kit';
import { EPublishTermsStatus } from '../../types/reducers/publishTerms';
import { selectIsSubagentLimitExceed, selectPublishTermsStatus } from '../../selectors/publishTerms';
import { EElementsVisibilitySummaryView } from '../../types/reducers/elementsVisibility';
import { selectIsMobileLayout } from '../../selectors/layout';

export const SummaryContainer = () => {
  const isIdentificationNeeded = useSelector(selectIsIdentificationNeeded);
  const isPublishToHiddenBase = useSelector(selectIsPublishToHiddenBase);
  const isAutoProlongAvailable = useSelector(selectIsAutoProlongAvailable);
  const autoProlongTooltipText = useSelector(selectAutoProlongTooltipText);
  const summaryViewMode = useSelector(selectSummaryViewMode);
  const status = useSelector(selectPublishTermsStatus);
  const isSubagentLimitExceed = useSelector(selectIsSubagentLimitExceed);
  const isMobile = useSelector(selectIsMobileLayout);

  const showMultilineTotal = summaryViewMode === EElementsVisibilitySummaryView.Multiline;
  const isError = status === EPublishTermsStatus.fail;

  if (isError || isSubagentLimitExceed) {
    return null;
  }

  let Component = (
    <Device
      mobile={
        <SummaryMobile isAutoProlongVisible={isAutoProlongAvailable} autoProlongTooltipText={autoProlongTooltipText} />
      }
      desktop={<SummaryDesktop />}
    />
  );

  if (isIdentificationNeeded) {
    Component = <NeedIdentification />;
  }

  if (isPublishToHiddenBase) {
    Component = <HiddenBaseContainer />;
  }

  if (showMultilineTotal) {
    Component = <MultilineTotalContainer />;
  }

  return (
    <div data-name="Summary" data-testid="summary">
      <Layout>
        {!showMultilineTotal && !isMobile && (
          <Layout.Title>
            <Header2 data-testid="summary-title">Стоимость размещения</Header2>
          </Layout.Title>
        )}
        <Layout.Content>{Component}</Layout.Content>
      </Layout>
    </div>
  );
};
